export default "__VITE_ASSET__05bcced4__"